export default __webpack_public_path__ + "static/media/Jazz.2c1dbd9b.mp3";